var map = {
	"./I_was_alone.png": 5444,
	"./arts-section.webp": 6833,
	"./arts/arts_1.png": 5236,
	"./arts/arts_10.png": 9662,
	"./arts/arts_11.png": 7975,
	"./arts/arts_12.png": 7916,
	"./arts/arts_13.png": 7013,
	"./arts/arts_14.png": 506,
	"./arts/arts_15.png": 8083,
	"./arts/arts_16.png": 2808,
	"./arts/arts_17.png": 673,
	"./arts/arts_18.png": 8742,
	"./arts/arts_19.png": 5071,
	"./arts/arts_2.png": 511,
	"./arts/arts_20.png": 8127,
	"./arts/arts_21.png": 3030,
	"./arts/arts_22.png": 6797,
	"./arts/arts_23.png": 5668,
	"./arts/arts_24.png": 7659,
	"./arts/arts_25.png": 4002,
	"./arts/arts_26.png": 8009,
	"./arts/arts_27.png": 5904,
	"./arts/arts_28.png": 6087,
	"./arts/arts_29.png": 6094,
	"./arts/arts_3.png": 3062,
	"./arts/arts_30.png": 5124,
	"./arts/arts_31.png": 9021,
	"./arts/arts_32.png": 5046,
	"./arts/arts_33.png": 1983,
	"./arts/arts_34.png": 656,
	"./arts/arts_4.png": 3033,
	"./arts/arts_5.png": 8832,
	"./arts/arts_6.png": 43,
	"./arts/arts_7.png": 8498,
	"./arts/arts_8.png": 7653,
	"./arts/arts_9.png": 6028,
	"./experience-section.webp": 7203,
	"./experience/developer_gisselles_adventure/capsula_principal.png": 1740,
	"./experience/developer_gisselles_adventure/clausula_vertical.png": 5353,
	"./experience/developer_gisselles_adventure/epic_store.png": 1413,
	"./experience/developer_gisselles_adventure/googleplay_store.png": 1285,
	"./experience/developer_gisselles_adventure/microsoft_store.png": 2532,
	"./experience/developer_gisselles_adventure/steam_store.png": 1712,
	"./experience/developer_gisselles_adventure/xbox_store.png": 4613,
	"./experience/web_developer_educ/educ_logo.png": 8573,
	"./experience/web_developer_educ/educ_logo_page.png": 4671,
	"./experience/web_developer_educ/interface_educ.png": 7371,
	"./experience/web_developer_educ/interface_educ2.png": 7697,
	"./experience/web_developer_educ/interface_educ3.png": 9832,
	"./experience/web_developer_educ/universidad_de_colima.png": 6082,
	"./games_section.webp": 4072,
	"./home_section1_bg.webp": 6277,
	"./projects/Raxor/00.PNG": 5778,
	"./projects/ReactNative/00.PNG": 3464,
	"./projects/chalenge_cshar/00.PNG": 2119,
	"./projects/chalenge_cshar/01.PNG": 5198,
	"./projects/chalenge_cshar/02.PNG": 6981,
	"./projects/gisselles_adventure/01.PNG": 1923,
	"./projects/gisselles_adventure/02.PNG": 3336,
	"./projects/gisselles_adventure/03.PNG": 849,
	"./projects/gisselles_adventure/04.PNG": 4158,
	"./projects/gisselles_adventure/06.PNG": 5100,
	"./projects/gisselles_adventure/07.PNG": 7733,
	"./projects/gisselles_adventure/08.PNG": 1746,
	"./projects/gisselles_adventure/09.PNG": 2363,
	"./projects/javascript-my-favnime/01.PNG": 7378,
	"./projects/javascript-my-favnime/02.PNG": 9033,
	"./projects/javascript-my-favnime/03.PNG": 6528,
	"./projects/javascript-my-favnime/04.PNG": 7855,
	"./projects/kotlin_gps_app/01.png": 8220,
	"./projects/kotlin_gps_app/02.png": 3303,
	"./projects/kotlin_gps_app/03.png": 3310,
	"./projects/kotlin_gps_app/04.png": 6401,
	"./projects/kotlin_sales_app/01.PNG": 7807,
	"./projects/kotlin_sales_app/02.PNG": 6948,
	"./projects/kotlin_sales_app/03.PNG": 2877,
	"./projects/kotlin_sales_app/04.PNG": 2098,
	"./projects/kotlin_sales_app/05.PNG": 3115,
	"./projects/kotlin_sales_app/06.PNG": 4592,
	"./projects/kotlin_sales_app/07.PNG": 4713,
	"./projects/kotlin_sales_app/08.PNG": 9150,
	"./projects/kotlin_sales_app/09.PNG": 9575,
	"./projects/lora_chan_AI/00.png": 3439,
	"./projects/lora_chan_AI/01.png": 3462,
	"./projects/lora_chan_AI/videos_demostration/code_for_voice.mp4": 9329,
	"./projects/lora_chan_AI/videos_demostration/code_writing_demostration.mp4": 7929,
	"./projects/lora_chan_AI/videos_demostration/voice_commands.mp4": 7974,
	"./projects/myYTR_cshar/ytr_0.png": 748,
	"./projects/myYTR_cshar/ytr_1.png": 7285,
	"./projects/myYTR_cshar/ytr_2.png": 3278,
	"./projects/myYTR_cshar/ytr_3.png": 2503,
	"./projects/myYTR_cshar/ytr_4.png": 9864,
	"./projects/myYTR_cshar/ytr_5.png": 993,
	"./projects/prototype-html-servicios/01.PNG": 641,
	"./projects/prototype-html-servicios/02.PNG": 2810,
	"./projects/prototype-html-servicios/03.PNG": 419,
	"./projects/prototype-html-servicios/04.PNG": 8764,
	"./projects/prototype-html-servicios/05.PNG": 2085,
	"./projects/prototype-html-servicios/06.PNG": 2878,
	"./projects/react_chat/rc_0.png": 5361,
	"./projects/react_chat/rc_1.png": 4232,
	"./projects/react_chat/rc_10.png": 186,
	"./projects/react_chat/rc_2.png": 9987,
	"./projects/react_chat/rc_3.png": 4778,
	"./projects/react_chat/rc_4.png": 1653,
	"./projects/react_chat/rc_5.png": 6383,
	"./projects/react_chat/rc_6.png": 6871,
	"./projects/react_chat/rc_7.png": 7646,
	"./projects/react_chat/rc_8.png": 3209,
	"./projects/react_chat/rc_9.png": 6960,
	"./projects/react_todo_list/rc_0.png": 1300,
	"./projects/react_todo_list/rc_1.png": 4541,
	"./projects/react_todo_list/rc_2.png": 2774,
	"./projects/react_todo_list/rc_3.png": 6575,
	"./projects/react_todo_list/rc_4.png": 8544,
	"./projects/react_todo_list/rc_5.png": 2745,
	"./projects/react_todo_list/rc_6.png": 4562,
	"./projects/react_todo_list/rc_7.png": 6107,
	"./projects/react_todo_list/rc_8.png": 2092,
	"./projects/react_todo_list/rc_9.png": 3717,
	"./projects/unity_3d_game/UG_0.png": 5016,
	"./projects/unity_3d_game/UG_1.png": 7057,
	"./projects/unity_3d_game/UG_2.png": 7162,
	"./projects/unity_3d_game/UG_3.png": 6995,
	"./projects/unity_3d_game/UG_4.png": 7596,
	"./projects/unreal_bp_project/UE_0.png": 1326,
	"./projects/unreal_bp_project/UE_1.png": 4343,
	"./projects/unreal_bp_project/UE_2.png": 3708,
	"./projects/unreal_bp_project/UE_3.png": 3125,
	"./projects/unreal_bp_project/UE_4.png": 8458,
	"./projects/unreal_bp_project/UE_5.png": 7315,
	"./projects/unreal_bp_project/UE_6.png": 2824,
	"./projects/unreal_bp_project/UE_7.png": 7441,
	"./projects/unreal_bp_project/UE_8.png": 1286,
	"./projects/unreal_bp_project/UE_9.png": 303,
	"./projects_section.webp": 9791,
	"./rotative_card_1.png": 9764,
	"./rotative_card_2.png": 3327,
	"./rotative_card_3.png": 5238,
	"./rotative_card_4.png": 9497,
	"./rotative_card_5.png": 4672,
	"./skills/hard-skills/Blazor.png": 2631,
	"./skills/hard-skills/astudio.png": 5504,
	"./skills/hard-skills/blender.png": 9739,
	"./skills/hard-skills/c.png": 8416,
	"./skills/hard-skills/english.png": 1371,
	"./skills/hard-skills/git.png": 8075,
	"./skills/hard-skills/github.png": 4830,
	"./skills/hard-skills/godot.png": 2740,
	"./skills/hard-skills/java.png": 2011,
	"./skills/hard-skills/js.png": 5742,
	"./skills/hard-skills/kotlin.png": 2620,
	"./skills/hard-skills/nodejs.png": 8778,
	"./skills/hard-skills/phpicon.png": 2096,
	"./skills/hard-skills/phpmyadmin.png": 6144,
	"./skills/hard-skills/ps.png": 9304,
	"./skills/hard-skills/reactjs.png": 5919,
	"./skills/hard-skills/reactnative.png": 2615,
	"./skills/hard-skills/sechar.png": 1003,
	"./skills/hard-skills/siplusplus.png": 6819,
	"./skills/hard-skills/sql-workbench.png": 871,
	"./skills/hard-skills/sqlsever.png": 6572,
	"./skills/hard-skills/unity.png": 3396,
	"./skills/hard-skills/unreal_engine.png": 9701,
	"./skills/hard-skills/vuejs.png": 1934,
	"./skills/hard-skills/xamarin.png": 1013,
	"./skills/soft-skills/adaptability.png": 298,
	"./skills/soft-skills/communication.png": 1634,
	"./skills/soft-skills/empathy.png": 1202,
	"./skills/soft-skills/hard_working.png": 9319,
	"./skills/soft-skills/organized.webp": 2993,
	"./skills/soft-skills/problem-solving.png": 5120,
	"./skills/soft-skills/resilience.jpg": 7303,
	"./skills/soft-skills/stress_m.png": 5288,
	"./skills/soft-skills/teamwork.png": 6752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;